// extracted by mini-css-extract-plugin
module.exports = {"wounds-location-tab-container":"style_wounds-location-tab-container__4KTfy","headline":"style_headline__22RhS"};